import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getCostCenterItems,
    getEmployeeCostCenters,
} from "../../../services/costCenterService";
import { EmployeeCostCentersResponse } from "../../../models/costCenter/EmployeeCostCentersResponse";
import { ICostCenterListItem } from "../../../models/costCenter/costCenterListItem";

export interface CostCenterState {
    costCenterItems: ICostCenterListItem[];
    employeeCostCenterItems: ICostCenterListItem[];
    hasEmployeeCostCenters: boolean;
}

const initialState: CostCenterState = {
    costCenterItems: null,
    employeeCostCenterItems: null,
    hasEmployeeCostCenters: false,
};

export const costCenterSlice = createSlice({
    name: "costCenter",
    initialState,
    reducers: {
        setCostCenters: (
            state,
            action: PayloadAction<ICostCenterListItem[]>
        ) => {
            state.costCenterItems = action.payload;
        },
        setEmployeeCostCenters: (
            state,
            action: PayloadAction<EmployeeCostCentersResponse>
        ) => {
            state.employeeCostCenterItems = action.payload.costCenters;
            state.hasEmployeeCostCenters =
                action.payload.hasEmployeeCostCenters;
        },
    },
});

export const { setCostCenters, setEmployeeCostCenters } =
    costCenterSlice.actions;

export const fetchCostCenters = createAsyncThunk(
    "costCenter/fetchCostCenters",
    async (_, thunkApi) => {
        const costCenterItems = await getCostCenterItems(thunkApi.signal);
        thunkApi.dispatch(setCostCenters(costCenterItems?.data));
    }
);

export const fetchEmployeeCostCenters = createAsyncThunk(
    "costCenter/fetchEmployeeCostCenters",
    async (_, thunkApi) => {
        const employeeCostCenters = await getEmployeeCostCenters(
            thunkApi.signal
        );
        thunkApi.dispatch(setEmployeeCostCenters(employeeCostCenters?.data));
    }
);

export const costCenterReducer = costCenterSlice.reducer;
